import React from 'react';
import PortRotation from './PortRotation';

export default function VoyagePlan(props) {
  return <PortRotation {...props} mode="voyage" />;
}
